import {
GET_COURSES_ERROR,
GET_COURSES_SUCCESS
} from "../../actionTypes/authActionTypes";
import initialState from "../../store/initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COURSES_SUCCESS:
      return {
        ...state,
        allCoursesData: action.payload,
      };
    case GET_COURSES_ERROR:
      return {
        ...state,
        coursesError: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
